import NotificationsPanel from './NotificationsPanel';

export default NotificationsPanel;
